/* Q Drinks – PDP story-band image fallback.
   On product pages, fills empty media-with-text image placeholders with the
   product's own media photos. A specific image set on a block overrides this
   (it renders an <img>, not a placeholder svg, so it is skipped). */
(function () {
  if (!/\/products\//.test(window.location.pathname)) return;

  function run() {
    var boxes = document.querySelectorAll('.shopify-section--media-with-text .media-with-text__media');
    if (!boxes.length) return;

    var targets = [];
    boxes.forEach(function (box) {
      var svg = box.querySelector('svg');
      if (svg) targets.push({ box: box, svg: svg });
    });
    if (!targets.length) return;

    var url = window.location.pathname.split('?')[0].replace(/\/+$/, '') + '.js';
    fetch(url, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p) return;
        var imgs = (p.images && p.images.length) ? p.images : [];
        if (!imgs.length) return;
        targets.forEach(function (t, i) {
          var src = imgs[i % imgs.length];
          var sized = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=900';
          var img = document.createElement('img');
          img.src = sized;
          img.alt = p.title || '';
          img.loading = 'lazy';
          img.decoding = 'async';
          img.style.cssText = 'width:100%;height:100%;object-fit:cover;display:block;border-radius:inherit;';
          t.svg.replaceWith(img);
        });
      })
      .catch(function () {});
  }

  document.readyState !== 'loading' ? run() : document.addEventListener('DOMContentLoaded', run);
})();
